module.exports = __webpack_public_path__ + "images/onboarding-documents.png";